import { authClient } from '~/lib/auth-client';
import { getPostHog } from '~/lib/posthog';

let recovering = false;

/**
 * The session is gone — expired, revoked, or signed out in another tab. The
 * stale cookie is cleared and the person is sent to sign in, then back to the
 * page they were on. Called from every place an auth error can surface, so it
 * runs once however many requests fail together.
 */
export function recoverSignedOutSession() {
  if (recovering) {
    return;
  }

  recovering = true;

  const returnTo = window.location.pathname + window.location.search;

  void authClient
    .signOut()
    .catch(() => null)
    .then(() => {
      getPostHog()?.reset();
      window.location.replace(
        `/sign-in?redirect=${encodeURIComponent(returnTo)}`,
      );
    });
}
